import {closeModal, pathIs, url} from "../utilities";
import {logs} from "./logs";
import Spinner from "../spinner";
import {toastAlert} from "../toastAlert";
import axios from "axios";
import * as $ from "jquery";
import {mobileAds} from "./mobile-ads";
import {inventories_page} from "./dictionaries/inventories";
import {handleApiForm} from "../forms";
import {confirmModal} from "../confirmModal";

if (pathIs(['/admin', '/admin*', '/admin/*'])) {
    if (pathIs('/admin/logs*')) {
        logs();
    }

    if (pathIs(['/admin/inventories', '/admin/inventories/*', '/admin/inventories*'])) {
        inventories_page();
    }

    $('button#btnAddAnimalModalOpen').click(function () {
        let name = $(this).data('animal_type_name');
        $("#modalHeaderTypeName").text(`Dodaj zwierzę do ${name}`);
        $("input[name='animal_type_id']").val($(this).data('animal_type_id'));
    })

    $(".btnEditSeason").click(function () {
        $("#editSeasonModal input[name='from']").val($(this).closest('tr').find('.season__from').text());
        $("#editSeasonModal input[name='id']").val($(this).closest('tr').data('id'));
        $("#editSeasonModal input[name='to']").val($(this).closest('tr').find('.season__to').text());
    })

    $(".btnEditSupervision").click(function () {
        $("#editSupervisionModal input[name='name']").val($(this).closest('tr').find('.name').text());
        $("#editSupervisionModal input[name='id']").val($(this).closest('tr').data('id'));
    })

    $("#sendEmails_should_delay").change(function () {
        $("#sendEmails_delay").attr('disabled', !$(this).prop('checked'))
    })

    $("#sendSms_should_delay").change(function () {
        $("#sendSms_delay").attr('disabled', !$(this).prop('checked'))
    })

    $("#btnPreviewEmail").click(function (e) {
        e.preventDefault();
        let form = $(this).closest('form');

        form.attr('target', '_blank');
        form.find('#preview').val('true');
        form.data('no-upload', true);
        form.submit();
        form.find('#preview').val('false');
        form.attr('target', '');
        form.data('no-upload', false);
    })

    $('.btnAddTrait').click(function () {
        let type = $(this).data('type');
        $('#addTraitModal input[name="trait_type"]').val(type);

        let modalTitle = $('#addTraitModal .modal-title');

        let hasAntlerInput = $('#addTraitModal input[name="has_antler"]').closest('.col-12');
        hasAntlerInput.hide();

        switch (type) {
            case 1:
                modalTitle.text('Dodaj typ');
                hasAntlerInput.show();
                break;
            case 2:
                modalTitle.text('Dodaj płeć');
                break;
            case 3:
                modalTitle.text('Dodaj wiek');
                break;
            case 4:
                modalTitle.text('Dodaj poroże');
                break;
        }
    })

    $('.btnEditTrait').click(function () {
        let type = $(this).data('type');
        let id = $(this).data('id');

        let modal = $('#editTraitModal');

        let hasAntlerInput = $('#editTraitModal input[name="has_antler"]').closest('.col-12');
        hasAntlerInput.hide();

        $('#editTraitModal input[name="trait_type"]').val(type);
        $('#editTraitModal input[name="trait_id"]').val(id);

        let modalTitle = $('#editTraitModal .modal-title');

        let row = $(this).closest('tr');
        let name = row.data('name');
        let enabled = row.data('enabled');
        let has_antler = row.data('has_antler');

        modal.find('input[name="name"]').val(name);
        modal.find('input[name="is_enabled"]').prop('checked', enabled);
        modal.find('input[name="has_antler"]').prop('checked', has_antler);

        switch (type) {
            case 1:
                modalTitle.text('Edytuj typ');
                hasAntlerInput.show();
                break;
            case 2:
                modalTitle.text('Edytuj płeć');
                break;
            case 3:
                modalTitle.text('Edytuj wiek');
                break;
            case 4:
                modalTitle.text('Edytuj poroże');
                break;
        }
    })

    $("#messagesTable").DataTable({
        order: [0, 'desc'],
        stateSave: false,
    });

    $("#seasonsTable").DataTable({
        order: [0, 'desc'],
        stateSave: false,
    });
}

if (pathIs('/admin/mobile-ads*')) {
    mobileAds();
}

let associationsLoaded = false;
$("#chooseAssociationModal").on('show.bs.modal', async function () {
    if (!associationsLoaded) {
        let spinner = new Spinner();
        try {
            let response = await axios.get(url('api/associations-list'));
            if (response.status === 200) {
                let table = $(this).find('table');
                for (let association of response.data) {
                    let row = $(`
                        <tr>
                            <td>${association.name}</td>
                            <td></td>
                            <td><a class="btn btn-sm btn-primary" href="${url('users/switch-association/' + association.id)}">Wybierz</a></td>
                        </tr>
                    `)
                    table.DataTable().api().rows.add(row);
                }
                table.DataTable().api().draw();
                associationsLoaded = true;
                spinner.destroy();
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas ładowania kół łowieckich', {type: 'danger'});
            spinner.destroy();
        }
    }
})

let seasonsLoaded = false;
$("#chooseSeasonModal").on('show.bs.modal', async function () {
    if (!seasonsLoaded) {
        let spinner = new Spinner();
        try {
            let response = await axios.get(url('api/seasons'));
            if (response.status === 200) {
                let table = $(this).find('table');
                for (let season of response.data) {
                    let row = $(`
                        <tr>
                            <td>${season.name}</td>
                            <td>
                                <a class="btn btn-sm btn-primary ${season.current ? 'disabled' : ''}" href="${url('users/switch-season/' + season.id)}">Wybierz</a>
                            </td>
                        </tr>
                    `)
                    table.DataTable().api().rows.add(row);
                }
                table.DataTable().api().draw();
                seasonsLoaded = true;
                spinner.destroy();
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas sezonów', {type: 'danger'});
            spinner.destroy();
        }
    }
})

$("#addUser_email").change(function () {
    if ($(this).val() !== "" && !$("#addUser_password").attr("disabled")) {
        $("#addUser_send_password").attr('disabled', false)
    } else {
        $("#addUser_send_password").attr('disabled', true)
    }
})

$("#addUser_send_password").change(function () {
    if ($(this).prop('checked')) {
        $("#addUser_password").attr('disabled', true);
    } else {
        $("#addUser_password").attr('disabled', false);
    }
})

if (pathIs('/admin/merge')) {
    $('body').on('click', '.btnChooseUser', function () {
        console.log('click')
        if ($(this).closest('table').hasClass('users-to-merge')) {
            $("#form_user_to_merge").val($(this).data('login'));
        } else {
            $("#form_final_user").val($(this).data('login'));
        }
    })

    $('.users-to-merge, .final-users').DataTable({
        deferRender: true,
        data: window._users,
        columnDefs: [
            {
                targets: 0,
                data: 'login'
            },
            {
                targets: 1,
                data: 'display_name'
            },
            {
                targets: 2,
                data: 'associations'
            },
            {
                targets: 3,
                data: 'id',
                render: function (data, type, row) {
                    return `
                        <button type="button" class="btn btn-sm btn-primary btnChooseUser"
                                data-bs-dismiss="modal" aria-label="Close"
                                data-type=""
                                data-login="${row.login}">
                                Wybierz
                        </button>
                    `
                }
            }
        ]
    })
}

if (pathIs('/admin/bugs*')) {
    $('body').on('click', '.btnChangeStatus', async function () {
        let spinner = new Spinner();
        let id = $(this).data('id');

        try {
            const response = await axios.post(url(`api/admin/bugs/${id}/change-status`));
            $(`.status-name[data-id="${id}"]`).text(response.data.status);
            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            toastAlert('Nie udało się zmienić stanu błędu.', {type: "danger"})
        }
    })

    $("#bugsList").DataTable({
        filters: {
            columns: [
                {
                    index: 5,
                    title: 'Status'
                }
            ]
        }
    })
}

if (pathIs('/admin/associations/sms*')) {

    let smsDetailsTable = $("#smsDetailsTable").DataTable({
        order: [1, 'asc'],
        stateSave: false,
        columnDefs: [
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ],
        drawCallback: function () {
            this.$('.status-info').each(function () {
                new bootstrap.Tooltip(this, {html: true});
            })
        },
    });

    $("#operationsTable").DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Operacja'
                }
            ]
        }
    });

    $(".detailsButton").click(async function () {

        let id = $(this).data('id');
        let response = await axios.get(url(`api/admin/associations/sms/details?id=${id}`));

        let sms = response.data.sms;

        let modalDOM = document.getElementById("smsDetails");

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show()

        $(".full-content").html(sms.content);

        smsDetailsTable.DataTable().api().rows().remove().draw();

        for (let receiver of sms.receivers) {
            if (parseInt(receiver.status) === 1) {
                receiver.status = 'W kolejce';
            } else if (parseInt(receiver.status) === 2) {
                receiver.status = 'Wysłano';
            } else {
                receiver.status = 'Błąd';
            }

            let row = $(`
            <tr>
                <td>${receiver.user.first_name}</td>
                <td>${receiver.user.last_name}</td>
                <td>${receiver.phone_number}</td>
            </tr>
        `);

            let td;
            if (receiver.status === 'Błąd') {
                td = $(`<td>${receiver.status} <i class="fas fa-info-circle text-primary status-info" data-bs-target="tooltip" title="${receiver.status_info}"></i></td>`);
            } else {
                td = $(`<td>${receiver.status}</td>`);
            }

            row.append(td);

            $("#smsDetailsTable tbody").append(row);
            smsDetailsTable.DataTable().api().rows.add(row).draw();
        }
    });


    $("#ordersTable").DataTable({
        stateSave: false,
        order: [0, 'desc'],
    })

    $('body').on('click', '.btnNotPaid, .btnPaid, .btnOrdered', async function () {

        let that = $(this);
        let id = that.data('id');
        let response = await axios.post(url(`api/admin/associations/sms/orders/${id}/change-status`));
        let data = response.data;
        if (parseInt(data.code) === 400) {
            toastAlert("Podczas zmiany statusu wystąpił błąd.", {type: "danger"});
        } else {
            toastAlert('Pomyślnie zmieniono status zamówienia.');
            if (parseInt(data.status) === 1) {
                that.removeClass('btnNotPaid');
                that.removeClass('btn-outline-primary')
                that.addClass('btnPaid');
                that.addClass('btn-primary');
                that.html('Opłacona')
            } else if (parseInt(data.status) === 0) {
                that.removeClass('btnPaid');
                that.addClass('btnNotPaid');
                that.removeClass('btn-outline-warning');
                that.addClass('btn-outline-primary');
                that.html('Wystawiona')
            }else{
                that.removeClass('btnPaid');
                that.addClass('btnNotPaid');
                that.removeClass('btn-primary');
                that.addClass('btn-outline-warning');
                that.html('Brak')
            }
        }

    })
}

if (pathIs('/admin/calendar*')) {

    $('.editTypeBtn').click(async function (){
        let id = $(this).data('id');

        try{
            let response = await axios.get(url(`api/admin/calendar/type/${id}/get`));
            let data = response.data;
            if(data.code !== 200){
                toastAlert('Podczas pobierania danych wystąpił błąd', {type:'danger'})
            }else{
                $('#editCalendarType_name').val(data.type.name);
                $('#editCalendarType_order').val(data.type.order);
                $("#editFormModelId").val(data.type.id);
            }
        }catch (e){
            toastAlert('Podczas pobierania danych wystąpił błąd', {type:'danger'})
        }
    });

    $('.addAnimalBtn').click(function (){
       let id = $(this).data('type_id');
       $('#addAnimalId').val(id);
    });

    $(".editPeriod").click(function (){
        let that = $(this);
        let id = that.data('period_id');
        let from = that.data('from');
        let to = that.data('to');
        let comments = that.data('comments');
        $('#editCalendarPeriod_from').val(from);
        $('#editCalendarPeriod_to').val(to);
        $('#editCalendarPeriod_comments').val(comments);
        $('#editPeriodId').val(id);
    })

    $(".deletePeriod").click(async function(){
        let id = $(this).data('id');
        try{
            let confirm = await confirmModal('Czy na pewno chcesz usunąć ten okres?');
            if(confirm) {
                await axios.post(url(`api/admin/calendar/animal/${id}/delete-period`));
                toastAlert('Pomyślnie usunięto okres');
                $(this).closest('tr').remove();
            }
        }catch (e){
            toastAlert('Podczas usuwania okresu wystąpił błąd', {type:'danger'});
        }
    })

    handleApiForm("#addCalendarPeriod", function ({response}) {

        let data = response.data.data;
        let tbody = $("#periodTable").find('tbody');

        data.from = data.from.replace('-', '/');
        data.from = data.from.replace('-', '/');
        data.from = data.from.replace('00:00', '');

        data.to = data.to.replace('-', '/');
        data.to = data.to.replace('-', '/');
        data.to = data.to.replace('00:00', '');

        let tr = $(`
        <tr>
            <td class="period__from">${data.from}</td>
            <td class="period__to">${data.to}</td>
            <td class="period__comments">${data.comments}</td>
            <td>
                <button type="button" 
                    class="btn btn-sm btn-primary me-2 editPeriod" 
                    data-bs-toggle="modal" 
                    data-bs-target="#editPeriod"
                    data-id="${data.hunting_calendar_animal_id}"
                    data-period_id="${data.id}"
                    data-from="${data.from}"
                    data-to="${data.to}"
                    data-comments="${data.comments}"
                >Edytuj</button>
                <button class="btn btn-sm btn-danger deletePeriod" type="button">Usuń</button>
            </td>
        </tr>   
        `)

        tbody.append(tr);

        $(".editPeriod").click(function (){
            let that = $(this);
            let id = that.data('period_id');
            let from = that.data('from');
            let to = that.data('to');
            let comments = that.data('comments');
            $('#editCalendarPeriod_from').val(from);
            $('#editCalendarPeriod_to').val(to);
            $('#editCalendarPeriod_comments').val(comments);
            $('#editPeriodId').val(id);
        })

        $(".deletePeriod").click(async function(){
            let id = $(this).data('id');
            try{
                let confirm = await confirmModal('Czy na pewno chcesz usunąć ten okres?');
                if(confirm) {
                    await axios.post(url(`api/admin/calendar/animal/${id}/delete-period`));
                    toastAlert('Pomyślnie usunięto okres');
                    $(this).closest('tr').remove();
                }
            }catch (e){
                toastAlert('Podczas usuwania okresu wystąpił błąd', {type:'danger'});
            }
        })

        let modal = $("#addPeriod");
        closeModal(modal);
        toastAlert('Pomyślnie dodano okres');
    })

    handleApiForm("#editCalendarPeriod", function ({response}) {

        let data = response.data.data;
        data.from = data.from.replace('-', '/');
        data.from = data.from.replace('-', '/');
        data.from = data.from.replace('00:00', '');

        data.to = data.to.replace('-', '/');
        data.to = data.to.replace('-', '/');
        data.to = data.to.replace('00:00', '');

        let tr = $(`button[data-period_id=${data.id}]`).closest('tr');

        tr.find('.period__from').html(data.from);
        tr.find('.period__to').html(data.to);
        tr.find('.period__comments').html(data.comments);

        let editBtn = tr.find('.btn-primary');
        editBtn.data('comments', data.comments);
        editBtn.data('from', data.from);
        editBtn.data('to', data.to);

        toastAlert('Pomyślnie edytowano okres');

        let modal = $("#editPeriod");
        closeModal(modal);
    })

    $(".editPhotoBtn").click(function(){
        let id = $(this).data("id");
        $("#editPhotoId").val(id);
    })

}


